<template>
	<!-- Main layouts wrapper, to allow live-switching between different layouts -->
	<!-- (Can be removed once we've decided on a final layout). -->
	<div>
		<Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
			<slot />
		</Vertical>

		<Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
			<slot />
		</Horizontal>

		<Detached v-if="layoutType === 'detached'" :layout="layoutType">
			<slot />
		</Detached>
	</div>
</template>

<script>
import { layoutComputed } from '@/store/helpers'
import Horizontal from '@/views/layouts/Horizontal'
import Vertical from '@/views/layouts/Vertical'
import Detached from '@/views/layouts/Detached'

export default {
	components: { Horizontal, Vertical, Detached },
	computed: {
		...layoutComputed
	}
}
</script>
